export enum FilterActionEvent {
  locationUpdated = 'locationUpdated',
}
